<template>
  <q-chip
    class="color-chip"
    clickable
    color="white"
    :disable="disable"
    :class="{'selected': selected}"
    @click="$emit('click')"
  >
    <q-avatar
      :style="{'background-color': color, 'color': checkBrightnessOfHex(color) > 170 ? '#000' : '#fff'}"
      :icon="selected ? 'mdi-check' : undefined"
      font-size="1em"
    />
    <span v-if="label" class="q-px-sm">
      {{ label }}
    </span>
    <q-menu
      v-if="clearable"
      context-menu
      touch-position
    >
      <q-card>
        <q-list dense>
          <q-item-wrapper
            icon="mdi-close"
            label="Remove"
            label-class="text-bold"
            color="red-7"
            clickable
            @click="$emit('remove')"
          />
        </q-list>
      </q-card>
    </q-menu>
  </q-chip>
</template>

<script>
export default {
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click', 'remove']
}
</script>

<style lang="scss" src="./colorchip.scss" />
